import {
  Dropdown,
  FontWeights,
  getTheme,
  IButtonStyles,
  Icon,
  IconButton,
  IIconProps,
  mergeStyleSets,
  Modal,
  ResponsiveMode,
} from "@fluentui/react";
import React from "react";
import { FormTreeSelection } from "../cpm/FormTree";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { SourceTypeEnum } from "../../api/models/source-type-enum";
import { ScrollableFileTree } from "../document/FileTree";

interface FileDropDownProps {
  isModalOpen: boolean;
  isFileExcelExisting?: boolean;
  fileExcelName?: string;
  updateFileExcelName?: (fileExcelName: string) => void;
  isComponentInstance?: boolean;
  isLocked?: boolean;
}

export const FileDropDown = (input) => {
  // eslint-disable-next-line no-undef
  const onRenderCaretDown = (): JSX.Element => {
    return isComponentInstance ? null : <Icon iconName="More" />;
  };

  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    header: [
      theme.fonts.xLarge,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
  });
  const iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "10px",
    },
    rootHovered: {
      color: theme.palette.neutralDark,
    },
  };

  const cancelIcon: IIconProps = { iconName: "Cancel" };

  const [state, setState] = React.useState<FileDropDownProps>({
    isModalOpen: false,
  });

  const { isModalOpen } = state;
  const { form, objectSource, isFileExcelExisting, fileExcelName, isComponentInstance, isLocked } = input;

  function onFileClick(formSelection: FormTreeSelection) {
    setState({ ...state, isModalOpen: false });
    console.log(input.updateFileExcelName);
    console.log(typeof input.updateFileExcelName);

    input.onFileClick(formSelection);
    input.updateFileExcelName(formSelection.formDesc);
  }

  function getFileName() {
    if (form) {
      if (objectSource !== SourceTypeEnum.EXCEL || fileExcelName === "") {
        return form.desc;
      } else {
        return fileExcelName;
      }
    }
    return formatMessage("cof.base.select");
  }

  return (
    <>
      <Dropdown
        id="file_dropdown"
        placeholder={getFileName()}
        label="File:"
        onRenderCaretDown={onRenderCaretDown}
        options={[]}
        onClick={() =>
          isFileExcelExisting && !isComponentInstance
            ? setState({ ...state, isModalOpen: true })
            : setState({ ...state })
        }
        responsiveMode={ResponsiveMode.large}
        disabled={objectSource !== SourceTypeEnum.EXCEL || !isFileExcelExisting || isComponentInstance || isLocked}
        required
      />

      <Modal
        titleAriaId={"titleId"}
        isOpen={isModalOpen}
        onDismiss={() => setState({ ...state, isModalOpen: false })}
        isBlocking={false}
        containerClassName={contentStyles.container}
        styles={{
          main: {
            minHeight: "100%",
            minWidth: "100%",
          },
        }}
      >
        <div className={contentStyles.header}>
          <span id={"titleId"}>File</span>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={() => setState({ ...state, isModalOpen: false })}
          />
        </div>
        <div className={contentStyles.body}>
          <ScrollableFileTree onFileClick={onFileClick} oidPath={form ? form.oidPath : undefined} />
        </div>
      </Modal>
    </>
  );
};
